import { getAmplitudeInstance } from '../amplitudeHelpers';
import GarminModalType from '../enums/GarminModalType';

type logGarminConnectModalViewedParams = {
  modal_type?: GarminModalType;
};

/**
 * The garmin connect modal is shown to the user.
 * @param params - Attributes to log with the amplitude event
 * @param params.modal_type - Describes the type of Garmin modal shown to the user.
 */
const logGarminConnectModalViewed = ({ modal_type }: logGarminConnectModalViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('garmin connect modal viewed', { 'modal type': modal_type }, callback);
};

export default logGarminConnectModalViewed;
